import { ChevronDownIcon as HeroChevronDownIcon } from '@heroicons/react/24/outline';
export const ChevronDownIcon = HeroChevronDownIcon;
